let mermaidLibPromise = null;

const getMermaid = async () => {
  if (!mermaidLibPromise) {
    mermaidLibPromise = import('mermaid/dist/mermaid.esm.mjs').then(mod => mod.default || mod);
  }
  return mermaidLibPromise;
};

class MermaidComponent extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }
        #diagram {
          width: 100%;
          height: 100%;
          background: white;
          border-radius: 8px;
          padding: 16px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .mermaid-container {
          position: relative;
        }
      </style>
      <div class="mermaid-container">
        <div id="diagram"></div>
          <div part="mermaid-download-btn" class="mermaid-download-btn" style="position:absolute;top:0px;right:0px;cursor:pointer">
          <svg  xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 48 48" >
            <path d="M43.2973 40.8108H4.59459C3.18919 40.8108 2 42 2 43.4054C2 44.8108 3.18919 46 4.59459 46H43.4054C44.8108 46 46 44.8108 46 43.4054C46 42 44.7027 40.8108 43.2973 40.8108Z" fill=""/>
          <path d="M22.4327 35.6216C23.1895 36.5946 24.4868 36.5946 25.2435 35.6216L35.9462 21.8919C36.8111 20.7027 36.0543 19.0811 34.5408 19.0811H28.0543V3.62162C28.0543 2.75676 27.2976 2 26.4327 2H21.676C20.8111 2 20.0543 2.75676 20.0543 3.62162V19.0811H13.4597C11.9462 19.0811 11.1895 20.8108 12.0543 21.8919L22.4327 35.6216Z" fill=""/>
          </svg>
        </div>
      </div>
    `;
    this.diagramContainer = this.shadowRoot.getElementById('diagram');
    this.observer = new MutationObserver(() => this.renderDiagram());
    this.setupDownloadButton();
  }

  static get observedAttributes() {
    return ['width', 'height', 'code'];
  }

  setupDownloadButton() {
    const downloadBtn = this.shadowRoot.querySelector('.mermaid-download-btn');
    if (downloadBtn) {
      downloadBtn.addEventListener('click', e => {
        e.preventDefault();
        this.downloadDiagram();
      });
    }
  }

  downloadDiagram() {
    try {
      const svg = this.diagramContainer.querySelector('svg');
      if (!svg) {
        console.warn('No SVG diagram found to download');
        return;
      }

      const svgData = svg.outerHTML;
      const blob = new Blob([svgData], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'mermaid-diagram.svg';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(url);
    } catch (error) {}
  }

  attributeChangedCallback(name) {
    if (name === 'width' || name === 'height') {
      this.updateSize();
    }
    if (name === 'code') {
      this.renderDiagram();
      console.log('2');
    }
  }

  connectedCallback() {
    this.observer.observe(this, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  updateSize() {
    const width = this.getAttribute('width');
    this.diagramContainer.style.width = `${width}px`;
  }

  async renderDiagram(code = null) {
    const diagramCode = code || this.getAttribute('code');
    if (!diagramCode) return;
    const mermaid = await getMermaid();

    const config = {
      startOnLoad: false,
      theme: 'default',
      themeVariables: {
        width: '100%',
        primaryColor: '#e0e0e0',
        primaryTextColor: '#000',
        primaryBorderColor: '#7C0200',
        lineColor: '#F8B229',
        secondaryColor: '#006100',
        tertiaryColor: '#fff'
      },
      suppressErrorRendering: true
    };

    mermaid.initialize(config);

    try {
      await mermaid.parse(diagramCode);
      const result = await mermaid.render('mermaid-diagram', diagramCode);
      this.diagramContainer.innerHTML = result.svg;
    } catch (err) {
      console.log('Mermaid rendering error2:', err);
    }
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }
}

customElements.define('mermaid-component', MermaidComponent);
